import {i18n, Icon} from 'mc/lib';
import {BaseField, Form, FormActions, FormBody} from 'mc/lib/form';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {Alert, Button, ListGroup, ListGroupItem} from 'reactstrap';
import {FieldArray, formValueSelector, propTypes, reduxForm} from 'redux-form';
import ObdobiField from './ObdobiField';
import './ObdobiListForm.scss';
import {obdobiPropType, validateObdobiList} from './utils';

const renderObdobiField = ({onRemove, ...props}) => (
    <div className="obdobi-field-wrapper">
        <ObdobiField {...props} inline/>
        <Button title={i18n('obdobi.remove')} onClick={onRemove}>
            <Icon icon="trash-o"/>
        </Button>
    </div>
);

const renderObdobi = (name, index, fields) => (
    <ListGroupItem key={index} className="obdobi-list-form-row">
        <BaseField componentClass={renderObdobiField}
                   name={name} label={false}
                   onRemove={() => fields.remove(index)}/>
    </ListGroupItem>
);

const renderObdobiList = ({fields}) => (
    <div>
        <ListGroup>
            {fields.map(renderObdobi)}
        </ListGroup>
        <Button onClick={() => fields.push({})} className="mt-3">
            <Icon icon="plus"/> {i18n('obdobi.add')}
        </Button>
    </div>
);

/**
 * Formulář pro zadání seznamu SH období.
 */
const ObdobiListForm = ({handleSubmit, onClose, empty}) => (
    <Form onSubmit={handleSubmit}>
        <FormBody>
            {empty && (
                <Alert color="warning">{i18n('obdobi.emptyList')}</Alert>
            )}
            <FieldArray name="obdobiList" component={renderObdobiList}/>
        </FormBody>
        <FormActions onClose={onClose} storeButton cancelButton/>
    </Form>
);

ObdobiListForm.formName = 'obdobiList';

ObdobiListForm.propTypes = {
    initialValues: PropTypes.shape({
        obdobiList: PropTypes.arrayOf(obdobiPropType),
    }),
    empty: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    onClose: PropTypes.func,
    ...propTypes,
};

ObdobiListForm.validate = values => ({
    obdobiList: validateObdobiList(values.obdobiList),
});

const selectFormValue = formValueSelector(ObdobiListForm.formName);

const mapStateToProps = state => ({
    empty: selectFormValue(state, 'obdobiList').length === 0,
});

const formConfig = {
    form: ObdobiListForm.formName,
    validate: ObdobiListForm.validate,
};

const connectedObject = connect(mapStateToProps)(ObdobiListForm);
export default reduxForm(formConfig)(connectedObject);
